




























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiWorkOrderTypeAdd, apiWorkOrderTypeEdit, apiWorkOrderTypeDetail } from '@/api/work_order'
import MaterialSelect from '@/components/material-select/index.vue'

@Component({
  components: {
    MaterialSelect
  }
})
export default class WorkOrderTypeEdit extends Vue {
    form: any = {
      type_name: '',
      type_code: '',
      service_category: 1,
      icon: '',
      color: '#409EFF',
      description: '',
      require_quotation: 1,
      require_payment: 1,
      require_warranty: 0,
      default_warranty_days: 0,
      require_inspection: 0,
      require_signature: 0,
      require_photos: 0,
      base_hourly_rate: 0,
      base_fee_min: 0,
      base_fee_max: 0,
      sort: 255,
      status: 1
    }

    rules = {
      type_name: [
        { required: true, message: '请输入类型名称', trigger: 'blur' },
        { max: 100, message: '类型名称不能超过100个字符', trigger: 'blur' }
      ],
      type_code: [
        { required: true, message: '请输入类型编码', trigger: 'blur' },
        { max: 50, message: '类型编码不能超过50个字符', trigger: 'blur' }
      ],
      service_category: [
        { required: true, message: '请选择服务分类', trigger: 'change' }
      ],
      description: [
        { required: true, message: '请输入类型描述', trigger: 'blur' },
        { max: 500, message: '类型描述不能超过500个字符', trigger: 'blur' }
      ],
      icon: [
        { required: true, message: '请上传图标图片', trigger: 'change' }
      ]
    }

    // Tab配置
    tabs = ['basic', 'process', 'fee', 'other']
    activeTab = 'basic'
    loading = false
    inspectionRoles: string[] = []
    roleOptions = ['租客', '房东', '管理员', '客服', '维修主管']

    get isEdit () {
      return this.$route.query.id
    }

    get alertTitle () {
      return this.isEdit
        ? '温馨提示：编辑工单类型信息，修改后会影响相关工单的设置。'
        : '温馨提示：新增工单类型需要完善基本信息、流程设置、费用设置等内容。'
    }

    // 下一步
    handleNext () {
      this.validateCurrentTab().then((valid: boolean) => {
        if (valid) {
          const currentIndex = this.tabs.indexOf(this.activeTab)
          if (currentIndex < this.tabs.length - 1) {
            this.activeTab = this.tabs[currentIndex + 1]
          }
        }
      })
    }

    // 上一步
    handlePrev () {
      const currentIndex = this.tabs.indexOf(this.activeTab)
      if (currentIndex > 0) {
        this.activeTab = this.tabs[currentIndex - 1]
      }
    }

    // 验证当前tab的表单
    validateCurrentTab (): Promise<boolean> {
      return new Promise((resolve) => {
        let fieldsToValidate: string[] = []

        switch (this.activeTab) {
          case 'basic':
            fieldsToValidate = ['type_name', 'type_code', 'service_category', 'description', 'icon']
            break
          case 'process':
            // 流程设置页没有必填字段，直接通过
            resolve(true)
            return
          case 'fee':
            // 费用设置页没有必填字段，直接通过
            resolve(true)
            return
          case 'other':
            // 其他设置页没有必填字段，直接通过
            resolve(true)
            return
        }

        if (fieldsToValidate.length === 0) {
          resolve(true)
          return
        }

        (this.$refs.formRef as any).validate((valid: boolean) => {
          if (valid) {
            resolve(true)
          } else {
            const errorElements = document.getElementsByClassName('el-form-item__error')
            if (errorElements.length > 0) {
              errorElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            resolve(false)
          }
        })
      })
    }

    handleSubmit () {
      this.validateCurrentTab().then((valid: boolean) => {
        if (valid) {
          this.loading = true
          const params = { ...this.form }

          // 处理验收角色
          if (this.form.require_inspection && this.inspectionRoles.length) {
            params.inspection_role = JSON.stringify(this.inspectionRoles)
          } else {
            params.inspection_role = '[]'
          }

          if (this.isEdit) {
            params.id = this.$route.query.id
          }

          const api = this.isEdit ? apiWorkOrderTypeEdit : apiWorkOrderTypeAdd

          api(params).then(() => {
            this.$router.push('/work_order/type')
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }

    getWorkOrderTypeDetail () {
      if (this.isEdit) {
        apiWorkOrderTypeDetail({ id: this.$route.query.id }).then((res: any) => {
          const data = res || {}
          Object.keys(this.form).forEach(key => {
            if (data[key] !== undefined) {
              this.form[key] = data[key]
            }
          })

          // 处理验收角色
          if (data.inspection_role) {
            try {
              this.inspectionRoles = JSON.parse(data.inspection_role)
            } catch (e) {
              this.inspectionRoles = []
            }
          }
        })
      }
    }

    created () {
      this.getWorkOrderTypeDetail()

      if (!this.isEdit) {
        // 生成类型编码
        const date = new Date()
        const year = date.getFullYear().toString().slice(-2)
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
        this.form.type_code = `OT${year}${month}${day}${random}`
      }
    }

    @Watch('form.require_inspection')
    onRequireInspectionChange (val: number) {
      if (!val) {
        this.inspectionRoles = []
      }
    }

    @Watch('form.require_warranty')
    onRequireWarrantyChange (val: number) {
      if (!val) {
        this.form.default_warranty_days = 0
      }
    }
}
